export const CATEGORIES = [
  "Tote Packages",
  "Dollies & Carts",
  "Packing Supplies",
];

export const MARQUEE_ITEMS = [
  "Industrial Grade Plastic Totes",
  "Free Delivery",
  "Sanitized Every Time",
  "Incredible Customer Service",
  "Dollies & Carts",
  "Zero Cardboard",
  "Pick Up & Delivery Options Available",
  "Central Oregon",
];

export const HERO_IMAGE = "/brand/doorstep.jpg";
export const FAMILY_IMAGE = "/brand/family.jpg";
export const INFOGRAPHIC_IMAGE = "/brand/infographic.png";
